/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * A React component for Audio Pause icon.
 *
 * @author Sai Haripriya Yerra
 */
const AudioPause = props => (
  <SvgIcon viewBox="0 0 48 48" {...props}>
    <path
      d="M26 33V15a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1h-6a1 1 0 0
      1-1-1zM14 15a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1h-6a1 1 0 0
      1-1-1V15zm10 33c13.234 0 24-10.766 24-24C48 10.768 37.234 0 24 0S0 10.768
      0 24c0 13.234 10.766 24 24 24z"
    />
  </SvgIcon>
);

export default AudioPause;



// WEBPACK FOOTER //
// ./src/js/icons/AudioPause.jsx